import axios from 'axios';
import config from '@/api/config';

export default {
    request(method, uri, data = null, settings, adminAccess = false) {
        let headers;
        if (!settings) {
            let mainToken = localStorage.getItem('access_token');

            let adminToken = null
            try {
                if(adminAccess) {
                    let originalCredentials = JSON.parse(localStorage.getItem('originalCredentials'))
                    adminToken = originalCredentials.accessToken
                    if (adminToken) mainToken = adminToken
                }
            } catch (error) {}

            let token = mainToken ? mainToken : localStorage.getItem('anonymous_token');

            headers = {
                Authorization: 'Bearer ' + token,
                'airvote-language': localStorage.getItem('lang')
            };
        } else {
            headers = settings;
        }

        if (!method) {
            console.error('API function call requires method argument');
            return;
        }

        if (!uri) {
            console.error('API function call requires uri argument');
            return;
        }

        var url = config.baseUrl + uri;

        return new Promise((resolve, reject) => {
            axios({method, url, data, headers})
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    },
};
